import { render, staticRenderFns } from "./PostingTOModal.vue?vue&type=template&id=52c81e72&scoped=true&"
import script from "./PostingTOModal.vue?vue&type=script&lang=js&"
export * from "./PostingTOModal.vue?vue&type=script&lang=js&"
import style0 from "./PostingTOModal.vue?vue&type=style&index=0&id=52c81e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c81e72",
  null
  
)

export default component.exports